// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"a36a3712","407":"c76da59a","412":"abd8ad2e","419":"2fb01505","586":"470f6a43","970":"96cc063d"}[chunkId] + ".chunk.js";
};